import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasMicroButtonComponent } from './gas-micro-button.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasMicroButtonComponent,
];

@NgModule({
  imports: [
    CommonModule,
    GasIconsModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasMicroButtonModule { }
